<ng-container *ngIf="validationMessages$ | async as messages">
    <div *ngIf="control.invalid && control.touched" class="validation-messages">
        <div *ngFor="let message of messages" class="validation-message">
            <mat-icon>warning</mat-icon>
            <span>{{ message }}</span>
        </div>
    </div>
</ng-container>
